import React from 'react'

import { Route, Redirect } from 'react-router'

import config from 'config/routes'
import { checkValidSession } from 'utils/routes'

import Account from './Account'
import { AccountDetails } from './AccountDetails'
import MyDeliveries from './MyDeliveries'
import { MyGousto } from './MyGousto'
import { RecipeFeedback } from './RecipeFeedback'
import { Referral } from './Referral'
import SubscriptionSettings from './Subscription'

export const accountRoutes = (store) => (
  <Route component={Account} onEnter={checkValidSession(store, config.client.home, true)}>
    {AccountDetails}
    {MyGousto}
    {MyDeliveries}
    {SubscriptionSettings}
    {Referral}
    {RecipeFeedback}
    <Redirect
      from={`${config.client.deprecated__mySubscription}*`}
      to={`${config.client.mySubscription}*`}
    />
    <Redirect from={`${config.client.deprecated__myDetails}*`} to={`${config.client.myDetails}*`} />
  </Route>
)
